
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/currency-converter/currencies/[slug]",
      function () {
        return require("private-next-pages/currency-converter/currencies/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/currency-converter/currencies/[slug]"])
      });
    }
  